import { lazy } from "react";

// project imports
import Loadable from "../components/Loadable";
import AuthLayout from "../layout/AuthLayout";

// login routing
const AuthLogin = Loadable(lazy(() => import("../pages/Authentication/AuthLogin")));
const AuthRegister = Loadable(lazy(() => import("../pages/Authentication/AuthRegister")));
const VerifyEmail = Loadable(lazy(() => import("../pages/Authentication/VerifyEmail")));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: "/",
    element: <AuthLayout />,
    children: [
        {
            path: "/",
            element: <AuthLogin />,
        },
        {
            path: "/authentication/register",
            element: <AuthRegister />,
        },
        {
            path: "/verify-email",
            element: <VerifyEmail />,
        },
    ],
};

export default AuthenticationRoutes;
